import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_PAYROLLCOMPONENTDETAIL,
  DELETE_PAYROLLCOMPONENTDETAIL,
  UPDATE_PAYROLLCOMPONENTDETAIL,
  ADD_NEW_PAYROLLCOMPONENTDETAIL,
} from "./actionType";

import {
  getPayrollComponentDetailSuccess,
  getPayrollComponentDetailFail,
  deletePayrollComponentDetailSuccess,
  deletePayrollComponentDetailFail,
  updatePayrollComponentDetailSuccess,
  updatePayrollComponentDetailFail,
  addPayrollComponentDetailSuccess,
  addPayrollComponentDetailFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approvePayrollComponentDetailApi,
  getPayrollComponentDetailApi,
  updatePayrollComponentDetailApi,
  deletePayrollComponentDetailApi,
  addNewPayrollComponentDetailApi
} from "../../helpers/backend_helper";

function* getPayrollComponentDetail({ payload: payrollComponentDetail }) {
  try {
    const response = yield call(getPayrollComponentDetailApi, payrollComponentDetail);
    yield put(getPayrollComponentDetailSuccess(GET_PAYROLLCOMPONENTDETAIL, response.data));
  } catch (error) {
    yield put(getPayrollComponentDetailFail(GET_PAYROLLCOMPONENTDETAIL, error));
  }
}

function* onUpdatePayrollComponentDetail({ payload: payrollComponentDetail }) {
  try {
    if (payrollComponentDetail.setApprove) {
      const response = yield call(approvePayrollComponentDetailApi, payrollComponentDetail);
      yield put(updatePayrollComponentDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updatePayrollComponentDetailApi, payrollComponentDetail);
      yield put(updatePayrollComponentDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updatePayrollComponentDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeletePayrollComponentDetail({ payload: payrollComponentDetail }) {
  try {
    const response = yield call(deletePayrollComponentDetailApi, payrollComponentDetail);
    yield put(deletePayrollComponentDetailSuccess({ payrollComponentDetail, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deletePayrollComponentDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewPayrollComponentDetail({ payload: payrollComponentDetail }) {
  try {
    const response = yield call(addNewPayrollComponentDetailApi, payrollComponentDetail);
    yield put(addPayrollComponentDetailSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addPayrollComponentDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetPayrollComponentDetail() {
  yield takeEvery(GET_PAYROLLCOMPONENTDETAIL, getPayrollComponentDetail);
}

export function* watchUpdatePayrollComponentDetail() {
  yield takeEvery(UPDATE_PAYROLLCOMPONENTDETAIL, onUpdatePayrollComponentDetail);
}

export function* watchDeletePayrollComponentDetail() {
  yield takeEvery(DELETE_PAYROLLCOMPONENTDETAIL, onDeletePayrollComponentDetail);
}

export function* watchAddNewPayrollComponentDetail() {
  yield takeEvery(ADD_NEW_PAYROLLCOMPONENTDETAIL, onAddNewPayrollComponentDetail);
}

function* payrollComponentDetailSaga() {
  yield all([
    fork(watchGetPayrollComponentDetail),
    fork(watchDeletePayrollComponentDetail),
    fork(watchUpdatePayrollComponentDetail),
    fork(watchAddNewPayrollComponentDetail)
  ]);
}

export default payrollComponentDetailSaga;
